import { render, staticRenderFns } from "./MergeLists.vue?vue&type=template&id=39e700d6&"
import script from "./MergeLists.vue?vue&type=script&lang=js&"
export * from "./MergeLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports